import { useState } from "react"
import DynamicFilterBar from "../../../../common/AdminCommonComponents/FilterBars/DynamicFilterBar/DynamicFilterBar"
import ProductSaleCommission from "./ProductSaleCommission/ProductSaleCommission"
import AffiliateMarketingCommission from "./AffiliateMarketingCommission/AffiliateMarketingCommission"
import AddNewCategoryCommissionForm from "./AddNewCategoryCommissionForm/AddNewCategoryCommissionForm"

const CommissionByProductCategory = () => {
  const tabs = [
    { key: "productSaleCommission", label: "Product Sale Commission" },
    { key: "affiliateMarketingCommission", label: "Affiliate Marketing Commission" },
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].key)
  const [addNewCategoryCommissionForm, setAddNewCategoryCommissionForm] = useState(false)

  return (
    <>
      <div className="bg-white shadow py-2">
        <DynamicFilterBar filterTabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} barType="yellow-without-bg" />
      </div>
      {addNewCategoryCommissionForm ? (
        <AddNewCategoryCommissionForm onClick={setAddNewCategoryCommissionForm} />
      ) : (
        <>
          {activeTab === "productSaleCommission" && <ProductSaleCommission onClick={setAddNewCategoryCommissionForm} />}
          {activeTab === "affiliateMarketingCommission" && <AffiliateMarketingCommission onClick={setAddNewCategoryCommissionForm} />}
        </>
      )}
    </>
  )
}

export default CommissionByProductCategory
